export default function () {
    return fetch('/config.json')
        .then((response) => response.json())
        .then((config) => {
            window.configLoaded = true
            window.config = config
        })
}
